var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2000,
    zoomAndPan: "magnify",
    viewBox: "0 0 1500 1499.999933",
    height: 2000,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "327715f21d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 233.597656 290.402344 L 869 290.402344 L 869 1207 L 233.597656 1207 Z M 233.597656 290.402344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c25e12541"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 500 290.402344 L 1238 290.402344 L 1238 1209.902344 L 500 1209.902344 Z M 500 290.402344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "961338493f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 812.296875 469.160156 L 1038.816406 469.160156 L 1038.816406 574.402344 L 812.296875 574.402344 Z M 812.296875 469.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9f6e592421"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 864.917969 469.160156 L 985.886719 469.160156 C 1014.949219 469.160156 1038.507812 492.71875 1038.507812 521.78125 C 1038.507812 550.84375 1014.949219 574.402344 985.886719 574.402344 L 864.917969 574.402344 C 835.859375 574.402344 812.296875 550.84375 812.296875 521.78125 C 812.296875 492.71875 835.859375 469.160156 864.917969 469.160156 Z M 864.917969 469.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dbef0ac35c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.296875 0.160156 L 226.71875 0.160156 L 226.71875 105.402344 L 0.296875 105.402344 Z M 0.296875 0.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5cf827bcb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.917969 0.160156 L 173.886719 0.160156 C 202.949219 0.160156 226.507812 23.71875 226.507812 52.78125 C 226.507812 81.84375 202.949219 105.402344 173.886719 105.402344 L 52.917969 105.402344 C 23.859375 105.402344 0.296875 81.84375 0.296875 52.78125 C 0.296875 23.71875 23.859375 0.160156 52.917969 0.160156 Z M 52.917969 0.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee55da51b6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 227,
    y: 0,
    height: 106
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#327715f21d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a2e1d",
    d: "M 802.121094 907.226562 L 868.449219 1022.460938 C 833.007812 1083.464844 798.105469 1143.476562 761.523438 1206.445312 C 613.921875 950.949219 468.113281 698.359375 233.597656 290.679688 L 366.171875 290.679688 C 546.027344 604.246094 647.398438 779.519531 748.601562 954.792969 C 752.160156 960.914062 756.203125 966.75 762.292969 976.429688 C 776.128906 952.230469 789.480469 929.601562 802.121094 907.226562 Z M 802.121094 907.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c25e12541)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a2e1d",
    d: "M 1027.070312 1209.320312 L 1159.5 1209.320312 C 1023.226562 972.957031 959.230469 862.019531 894.070312 749.058594 C 936.828125 749.058594 975.457031 749.742188 1014.058594 748.890625 C 1160.210938 745.84375 1266.453125 605.5 1230.097656 464.042969 C 1203.878906 362.101562 1113.324219 291.445312 1006.515625 291.105469 C 879.265625 290.761719 752.015625 290.878906 500.195312 290.992188 L 566.351562 406 C 793.378906 405.828125 895.949219 406.113281 998.375 405.828125 C 1037.34375 405.714844 1071.308594 416.761719 1096.128906 447.675781 C 1125.28125 484.085938 1131.628906 525.078125 1111.53125 567.609375 C 1090.75 611.5625 1054.511719 633.996094 1005.746094 634.195312 C 944.65625 634.480469 883.535156 634.421875 822.417969 634.421875 C 790.019531 634.363281 757.683594 634.363281 725.285156 634.363281 C 717.085938 634.421875 708.804688 635.21875 698.328125 635.84375 C 700.035156 639.632812 701.257812 642.707031 702.339844 645.296875 L 989.75 1144.785156 C 993.621094 1151.390625 997.519531 1158.109375 1027.070312 1209.320312 Z M 1027.070312 1209.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#961338493f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9f6e592421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 812, 469)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee55da51b6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dbef0ac35c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5cf827bcb3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a2e1d",
    d: "M 0.296875 0.160156 L 226.40625 0.160156 L 226.40625 105.402344 L 0.296875 105.402344 Z M 0.296875 0.160156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aba0beff0db70849a0ee70a6608ed6b8.svg";
export { ForwardRef as ReactComponent };